var _ellipse, _ellipse2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityAddressCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9097,
    cy: 22.9113,
    rx: 22.9097,
    ry: 22.9113,
    fill: "#3158F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8474_184600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 22.9097,
    cy: 22.9113,
    rx: 22.9097,
    ry: 22.9113,
    fill: "#3158F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8474_184600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0498 3.51495C29.5289 3.15555 31.3458 2.76621 32.1943 2.61646C35.738 3.51495 43.2748 8.03731 45.0716 18.9389C41.9271 18.9389 43.4245 22.0836 43.125 23.7308C42.4182 27.6186 40.5296 25.0286 39.8308 23.2816C39.5313 21.0354 37.9741 19.0887 36.5366 19.6877C35.0991 20.2866 32.6435 19.4381 31.5953 18.9389C30.7468 18.7393 29.2894 18.6095 30.2477 19.6877C31.206 20.7658 32.6435 21.235 33.2424 21.3349C35.5883 21.7841 35.7879 23.1318 32.6435 24.0303C25.4953 26.0728 24.7074 18.7892 24.8572 17.5912C24.977 16.6328 22.7109 15.6944 21.563 15.345C19.4667 13.9973 20.8143 12.7993 21.563 12.4998C22.3736 12.1755 24.2582 12.949 24.8572 11.9008C25.3363 11.0622 24.7573 10.6529 24.408 10.5531C23.8589 10.4033 22.2817 10.5531 20.3651 12.35C17.9693 14.5962 15.5735 11.6013 15.4238 11.4516C15.274 11.3018 14.8248 10.7028 14.0761 10.8526C13.4772 10.9724 12.7285 10.9025 12.429 10.8526C11.6804 10.7028 11.8301 9.95408 12.2793 9.50484C12.7028 9.08129 14.6252 8.50652 15.5735 8.30686C16.7215 8.25694 19.3469 7.70787 20.6645 5.9109C21.9822 4.11394 24.408 3.56486 25.4561 3.51495C26.4544 3.66469 28.5706 3.87434 29.0498 3.51495Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2312 6.36015C10.2728 6.00075 10.1331 4.91259 10.183 4.41343C12.9779 2.16722 18.5976 -1.66631 18.7174 0.969242C18.8672 4.26368 17.0703 6.65964 15.4238 5.61141C13.7772 4.56318 13.1772 5.61141 13.0274 5.61141C12.8777 5.61141 12.429 6.80939 11.2312 6.36015Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98454 11.0021C7.18726 10.8823 5.64024 12.6493 5.0914 13.5478C4.61224 13.7874 4.59227 14.3464 4.64219 14.596C4.88176 15.195 5.44078 14.8456 5.69034 14.596C5.84008 14.2466 6.55881 13.6376 8.23586 13.997C9.91291 14.3564 10.5318 13.5478 10.6316 13.0985C10.8315 12.4496 10.7818 11.1219 8.98454 11.0021Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1102 38.6343C23.0321 39.1134 22.563 40.5311 22.4631 41.18C22.0768 42.3784 23.0621 42.9765 24.1102 42.078C25.1584 41.1795 26.3563 41.3292 27.105 41.479C27.8536 41.6287 29.8002 41.4792 30.8484 39.3827C31.8965 37.2863 30.0997 36.9868 29.5007 37.7355C29.0216 38.3345 27.8037 38.4844 27.2547 38.4845C26.6557 38.3348 25.1883 38.1551 24.1102 38.6343Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78667 10.4821C6.94815 10.7217 5.64045 12.1793 5.09141 12.8781C4.84185 13.2274 4.43257 14.0159 4.79194 14.3752C5.15131 14.7346 5.64045 14.2255 5.8401 13.926C6.08966 13.6765 6.88825 13.2674 8.08614 13.6265C9.28403 13.9857 10.0826 13.4769 10.3322 13.1776C11.9793 10.1824 8.83482 10.1826 7.78667 10.4821Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8401 27.1038C1.28804 23.2702 3.44429 19.2171 5.09141 17.6697C6.7383 16.322 8.53557 17.6697 11.3806 15.5732C13.6566 13.8961 15.5233 14.9742 16.1721 15.723C16.5714 16.1223 17.969 16.921 20.3647 16.921C23.3595 16.921 23.2097 19.6164 23.5092 21.7129C23.8087 23.8093 23.659 23.2103 25.6055 25.9058C27.5521 28.6012 29.4987 27.553 30.8463 28.0023C32.1939 28.4515 32.0442 30.2485 30.8463 31.7459C29.6484 33.2434 26.6537 33.5429 24.4076 35.0404C22.1616 36.5379 21.8621 38.4846 21.1134 40.1318C20.3647 41.779 20.0653 42.0785 18.5679 42.378C17.0705 42.6775 15.7229 39.6825 15.7229 36.6876C15.7229 33.6927 13.9261 31.2967 11.9795 30.548C10.0329 29.7992 8.08614 28.751 5.8401 27.1038Z",
    fill: "#0F28E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityAddressCheckLarge);
export default __webpack_public_path__ + "static/media/entity_address_check_large.29ddc57ac5e3de3cd3a1aece8be9fe42.svg";
export { ForwardRef as ReactComponent };